"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RECORD_INDEX = void 0;
exports.DEFAULT_RECORD_INDEX = 0;
//# sourceMappingURL=resource-settings.consts.js.map